import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Status } from './Status';

export const Planner = types.compose(
  BaseEntity,
  types.model('Planner', {
    plannerId: types.maybe(types.identifierNumber),
    status: Status,
    explanation: types.maybe(types.string),
    matchList: types.optional(types.array(types.string), []),
    indictmentList: types.optional(types.array(types.string), []),
    scoreList: types.optional(types.array(types.number), []),
    startDate: types.string,
    endDate: types.string,
    runId: types.optional(types.number, -1),
    return: types.maybe(types.string),
  }),
);
